import { doGet, doPut, doPost, doDelete } from './common';

const getList = (pagination = undefined, sort = undefined, keyword = undefined) => {
  let filter = '';
  if (pagination) {
    filter = `?limit=${pagination.limit}&offset=${pagination.offset}`;
  }
  if (sort) {
    if (filter !== '') filter += `&sort=${sort}`;
    else filter = `?sort=${sort}`;
  }
  if (keyword) {
    if (filter !== '') filter += `&keyword=${keyword}`;
    else filter = `?keyword=${keyword}`;
  }
  return doGet(`/api/delivery${filter}`).then(res => (res.data))
    .catch(err => { })
    .finally(() => {

    });
}
const getListCount = (keyword) => {
  let filter = '';
  if (keyword) {
    filter = `?keyword=${keyword}`;
  }
  return doGet(`/api/delivery/count${filter}`).then(res => (res.data.count))
    .catch(err => { })
    .finally(() => {

    });
}

const getById = (id) => {
  return doGet(`/api/delivery/${id}`)
    .catch(err => { })
    .finally(() => {

    });
}

const insert = (params) => {
  return doPost(`/api/delivery`, params).then(res => (res.data)
  ).catch(err => {

  }).finally(() => {

  });
}

const update = (id, params) => {
  return doPut(`/api/delivery/${id}`, params).then(res => (res.data)
  ).catch(err => {

  }).finally(() => {

  });
}

const deleteById = (id) => {
  return doDelete(`/api/delivery/${id}`).then(data => (
    {

    }
  )).catch(err => {

  }).finally(() => {

  });
}

const insertGoods = (id, params) => {
  return doPost(`/api/delivery/${id}/goods`, params).then(res => (res.data)).catch(err => {

  }).finally(() => {

  });
}

const getGoodsList = (id) => {
  return doGet(`/api/delivery/${id}/goods`).then(res => (res.data))
    .catch(err => { })
    .finally(() => {

    });
}

const updateDeliveryById = (id, params) => {
  return doPost(`/api/delivery/${id}/deliveried`, params).then(res => (res.data))
    .catch(err => {

    }).finally(() => {

    });
}

const deleteDeliveryPalletById = (id, palletId) => {
  return doDelete(`/api/delivery/${id}/deliveried/pallet/${palletId}`).then(res => (res.data))
    .catch(err => {

    }).finally(() => {

    });
}

const deleteDeliveryPackageById = (id, packageId) => {
  return doDelete(`/api/delivery/${id}/deliveried/package/${packageId}`).then(res => (res.data))
    .catch(err => {

    }).finally(() => {

    });
}

const deleteDeliveryById = (id) => {
  return doDelete(`/api/delivery/${id}/deliveried`).then(res => (res.data))
    .catch(err => {

    }).finally(() => {

    });
}
const updateDeliveryDDCFeeById = (id, params) => {
  return doPut(`/api/delivery/${id}/ddc`, params).then(res => (res.data))
    .catch(err => {

    }).finally(() => {

    });
}
const updateDeliveryFeightFeeById = (id, params) => {
  return doPut(`/api/delivery/${id}/feight`, params).then(res => (res.data))
    .catch(err => {

    }).finally(() => {

    });
}

const updateDeliveryNoById = (id, params) => {
  return doPut(`/api/delivery/${id}/no`, params).then(res => (res.data))
    .catch(err => {

    }).finally(() => {

    });
}

const download = (id, param) => {
  return doGet(`/api/delivery/${id}/download`, param, 'blob').then(res => (res.data))
    .catch(err => { })
    .finally(() => {

    });
}

const downloadShipmark = (id, type, param) => {
  return doGet(`/api/delivery/${id}/download/shipmark/${type}`, param, 'blob').then(res => (res.data))
    .catch(err => { })
    .finally(() => {

    });
}

export {
  getList,
  getListCount,
  getById,
  update,
  insert,
  deleteById,
  insertGoods,
  getGoodsList,
  updateDeliveryById,
  deleteDeliveryById,
  updateDeliveryDDCFeeById,
  updateDeliveryFeightFeeById,
  updateDeliveryNoById,
  download,
  downloadShipmark,
  deleteDeliveryPalletById,
  deleteDeliveryPackageById
}